import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import styles from "./drawer.module.scss"

export interface IDrawerProps extends React.PropsWithChildren<unknown> {
    focused?: boolean;
    className?: string;
}

export const Drawer: React.FC<IDrawerProps> = (props) => {
    const [expanded, setExpanded] = useState<boolean>(true);

    return (
        <div className={`
            ${styles["drawer-wrapper"]} 
            ${props.focused ? styles["focused"] : ""}
            ${expanded ? styles["expanded"] : ""}
            ${props.className ? props.className : ""}`}>
            <IconButton
                className={styles["toggle"]}
                onClick={() => setExpanded(!expanded)}
                size="large">
                { expanded 
                    ? <ChevronLeft color="primary" /> 
                    : <ChevronRight color="primary" />
                } 
            </IconButton>
            <div className={styles["drawer"]}>
                <div className={styles["drawer-content"]}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}
